module.exports = __webpack_public_path__ + "static/img/6.c9790d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/6.png
// module id = HnLU
// module chunks = 0